module.exports = __webpack_public_path__ + "img/pad.0fb2f830.svg";